import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import api from './api';
import md5 from 'js-md5';
import Cookie from 'js-cookie';
// import iframeServe from '@/utils/iframe-serve';
// import { creatediframe } from './utils/bb';
// creatediframe();

// import './utils/rem';

import ElementUI from 'element-ui';

Vue.use(ElementUI);
// Vue.prototype.$iframes = new iframeServe('iframes');
Vue.prototype.$cookie = Cookie;
Vue.prototype.$api = api;
Vue.prototype.$md5 = md5;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
